'use es6';

import http from 'hub-http/clients/apiClient';
import { DEFAULT_PAGINATION_LIMIT } from 'DesignData/settings/api';
/**
 * GET designmanager/v1/modules/:customWidgetId/versions
 */

export function fetchCustomWidgetRevisions(customWidgetId, offset) {
  const query = {
    offset,
    limit: DEFAULT_PAGINATION_LIMIT
  };
  return http.get(`designmanager/v1/modules/${customWidgetId}/versions-counted`, {
    query
  });
}
/**
 * GET designmanager/v1/modules/:customWidgetId/versions/:versionId
 */

export function fetchCustomWidgetRevision(customWidgetId, revisionId) {
  return http.get(`designmanager/v1/modules/${customWidgetId}/versions/${revisionId}`);
}
/**
 * GET designmanager/v1/widgets/:globalWidgetId/versions
 */

export function fetchGlobalWidgetRevisions(globalWidgetId, offset) {
  const query = {
    offset,
    limit: DEFAULT_PAGINATION_LIMIT
  };
  return http.get(`designmanager/v1/widgets/${globalWidgetId}/versions-counted`, {
    query
  });
}
/**
 * GET designmanager/v1/layouts/:layoutId/versions-counted
 */

export function fetchLayoutRevisions(layoutId, offset) {
  const query = {
    offset,
    limit: DEFAULT_PAGINATION_LIMIT
  };
  return http.get(`designmanager/v1/layouts/${layoutId}/versions-counted`, {
    query
  });
}
/**
 * GET designmanager/v1/layouts/:layoutId/versions/:revisionId
 */

export function fetchLayoutRevision(layoutId, revisionId) {
  return http.get(`designmanager/v1/layouts/${layoutId}/versions/${revisionId}`);
}
/**
 * GET designmanager/v1/templates/:templateId/versions
 */

export function fetchTemplateRevisions(templateId, offset) {
  const query = {
    offset,
    limit: DEFAULT_PAGINATION_LIMIT
  };
  return http.get(`designmanager/v1/templates/${templateId}/versions-counted`, {
    query
  });
}
/**
 * GET designmanager/v1/templates/:templateId/versions/:revisionId
 */

export function fetchTemplateRevision(templateId, revisionId) {
  return http.get(`designmanager/v1/templates/${templateId}/versions/${revisionId}`);
}
/**
 *  GET designmanager/v1/raw-assets/:rawAssetId/versions
 */

export function fetchRawAssetRevisions(rawAssetId, offset) {
  const query = {
    offset,
    limit: DEFAULT_PAGINATION_LIMIT
  };
  return http.get(`designmanager/v1/raw-assets/${rawAssetId}/versions-counted`, {
    query
  });
}
/**
 *  GET designmanager/v1/raw-assets/:rawAssetId/versions/:revisionId
 */

export function fetchRawAssetRevision(rawAssetId, revisionId) {
  return http.get(`designmanager/v1/raw-assets/${rawAssetId}/versions/${revisionId}`);
}
/**
 * POST designmanager/v1/modules/:customWidgetId/versions/restore
 */

export function revertCustomWidget(customWidgetId, revisionId) {
  return http.post(`designmanager/v1/modules/${customWidgetId}/versions/restore-to-buffer`, {
    data: {
      versionId: revisionId
    }
  });
}
/**
 * POST designmanager/v1/widgets/:globalWidgetId/versions/restore
 */

export function revertGlobalWidget(globalWidgetId, revisionId) {
  return http.post(`designmanager/v1/widgets/${globalWidgetId}/versions/restore-to-buffer`, {
    data: {
      versionId: revisionId
    }
  });
}
/**
 * POST designmanager/v1/layouts/:layoutId/versions/restore
 */

export function revertLayout(layoutId, revisionId) {
  return http.post(`designmanager/v1/layouts/${layoutId}/versions/restore-to-buffer`, {
    data: {
      versionId: revisionId
    }
  });
}
/**
 * POST designmanager/v1/templates/:templateId/versions/restore
 */

export function revertTemplate(templateId, revisionId) {
  return http.post(`designmanager/v1/templates/${templateId}/versions/restore-to-buffer`, {
    data: {
      versionId: revisionId
    }
  });
}
/**
 *  POST  designmanager/v1/raw-assets/:rawAssetId/versions/restore-to-buffer
 */

export function revertRawAsset(rawAssetId, revisionId) {
  return http.post(`designmanager/v1/raw-assets/${rawAssetId}/versions/restore-to-buffer`, {
    data: {
      versionId: revisionId
    }
  });
}